import { Suspense, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import ErrorBoundary from '@components/ErrorBoundary/ErrorBoundary'
import DashboardGridSkeleton from '@components/skeletons/DashboardGridSkeleton/DashboardGridSkeleton'
import DashboardContent from '@components/DashboardContent/DashboardContent'
import DashboardUnavailable from '@components/DashboardContent/DashboardUnavailable/DashboardUnavailable'

import './DashboardEmbed.css'

export default function DashboardEmbed() {
  const { id } = useParams<{ id: string }>()
  const [isClient, setIsClient] = useState(false)
  useEffect(() => {
    setIsClient(true)
  }, [])
  if (!isClient) return <DashboardGridSkeleton />
  return (
    <div id="dashboard-embed">
      <ErrorBoundary errorComponent={DashboardUnavailable}>
        <Suspense fallback={<DashboardGridSkeleton />}>
          <DashboardContent isEmbed id={id} />
        </Suspense>
      </ErrorBoundary>
    </div>
  )
}
